import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { ENABLE_MODULE } from "./gql";

const useEnableModule = createDefaultMutationHook(ENABLE_MODULE);
export const useBulkEnableModule = createBulkMutationHook(ENABLE_MODULE);

export default useEnableModule;
